var _polygon, _path, _rect, _polygon2, _g, _polygon3, _g2, _path2, _path3, _polygon4, _path4, _path5, _path6, _path7, _polygon5, _path8, _path9, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRestaurant = function SvgRestaurant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "69px",
    viewBox: "-47 -25 140 69",
    enableBackground: "new -47 -25 140 69",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF200",
    points: "18.814,34.198 24.127,43.35 14.754,43.35 7.689,34.19 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF200",
    d: "M3.059,7.068L-4.176-5.383c0,0-1.27-1.646-0.699-2.58c0.512-0.844,2.953-0.418,2.953-0.418l66.725,7.495 l-1.129,3.937c0,0-0.375,1.033,0.188,1.22c0.568,0.188,0.941-0.095,1.408-0.374c0.469-0.282,8.156-6.09,8.156-6.09 s0.748-0.468,0.748-1.032c0-0.47-0.564-1.22-0.564-1.22l-6.088-8.06c0,0-0.844-0.938-1.219-0.657 c-0.27,0.199-0.469,0.657-0.469,1.407c0,0.752-0.191,4.03-0.191,4.03l-91.28-16.963c0,0-4.744-1.496-6.84,2.058 c-2.152,3.656,1.972,7.31,1.972,7.31l17.263,22.376L3.059,7.068z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -47,
    y: 9.983,
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    width: 5.532,
    height: 21.367
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    points: "-37.814,31.351 -37.814,9.983 -32.101,9.983 -22.729,21.695 -22.729,9.983 -16.547,9.983 -16.547,31.351 -22.445,31.351 -31.631,19.735 -31.631,31.351 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -13.455,
    y: 17.104,
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    width: 6.652,
    height: 5.995
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    stroke: "#EC008C",
    strokeWidth: 0.3,
    d: "M-10.125,20.111"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    points: "-3.799,31.351 -3.799,9.983 1.914,9.983 11.287,21.695 11.287,9.983 17.469,9.983 17.469,31.351 11.57,31.351 2.383,19.735 2.383,31.351 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.566,
    y: 17.104,
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    width: 6.654,
    height: 5.995
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    stroke: "#EC008C",
    strokeWidth: 0.3,
    d: "M23.889,20.111"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    d: "M30.229,20.479c0-6.152,5.279-11.134,11.795-11.134s11.795,4.99,11.795,11.134 c0,6.151-5.279,11.131-11.795,11.131C35.508,31.614,30.229,26.631,30.229,20.479z M42.023,25.782c2.996,0,5.432-2.367,5.432-5.299 c0-2.928-2.436-5.3-5.432-5.3c-3.004,0-5.432,2.372-5.432,5.3C36.592,23.407,39.027,25.782,42.023,25.782z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    d: "M56.17,9.983v13.216c0,0-0.279,8.343,9.465,8.343 c8.902,0,9.371-6.839,9.371-7.871V9.983H68.73v12.371c0,0,0.375,3.748-3.184,3.748c-3.281,0-3.281-3.464-3.281-3.464V9.983H56.17z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    points: "77.729,9.983 77.729,15.048 82.133,15.048 82.133,31.351 88.408,31.351 88.408,15.048 93,15.048 93,9.983 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    d: "M35.561,33.742c1.988,0,2.971,1.24,2.996,2.487c0.02,1.049-0.752,1.801-0.752,1.801s1.715,0.583,1.691,2.739 c-0.033,2.62-3.092,2.528-3.092,2.528h-4.408v-9.563h3.564V33.742z M34.947,36.15v1.199c0,0,0.865,0.092,0.865-0.592 C35.816,36.014,34.947,36.15,34.947,36.15z M34.947,39.693v1.265c0,0,1.416,0.188,1.408-0.62 C36.34,39.59,34.947,39.693,34.947,39.693z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    d: "M41.932,33.742v6.396c0,0-0.096,3.396,4.145,3.396c4.406,0,4.287-3.464,4.287-3.464v-6.327h-2.996v5.695 c0,0,0.023,1.521-1.291,1.521c-1.381,0-1.328-1.477-1.328-1.477v-5.739H41.932z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    d: "M57.555,33.742c1.191,0,3.088,0.864,3.064,3.023c-0.018,1.964-1.877,2.808-1.877,2.808l2.973,3.725h-3.607 l-1.805-2.765v2.765h-2.996v-9.563h4.248V33.742z M57.535,36.926c-0.025-0.84-1.221-0.792-1.221-0.792v1.664 C56.643,37.79,57.555,37.698,57.535,36.926z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    d: "M69.949,37.414l2.527-1.236c0,0-1.172-2.672-4.311-2.699 c-3.141-0.024-5.34,2.039-5.316,5.251c0.025,3.444,2.713,4.876,5.264,4.828c2.369-0.048,4.92-1.48,4.881-5.792h-5.369v2.32h1.832 c0,0-0.164,0.848-1.383,0.863c-1.24,0.024-2.137-0.863-2.137-2.388c0-1.523,0.729-2.579,1.949-2.604 C69.105,35.946,69.762,36.902,69.949,37.414z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1B2E",
    stroke: "#ED1C24",
    strokeWidth: 0.3,
    points: "75.473,33.742 75.473,43.298 81.266,43.298 81.266,40.533 78.617,40.533 78.617,39.762 81.072,39.762 81.072,37.158 78.617,37.158 78.617,36.202 81.244,36.202 81.244,33.742 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    d: "M88.717,33.742c1.195,0,3.092,0.864,3.066,3.023c-0.023,1.964-1.879,2.808-1.879,2.808l2.973,3.725h-3.613 l-1.799-2.765v2.765h-3v-9.563h4.252V33.742z M88.688,36.926c-0.023-0.84-1.215-0.792-1.215-0.792v1.664 C87.801,37.79,88.709,37.698,88.688,36.926z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    d: "M7.809,40.602c0,1.644-1.314,2.956-2.934,2.956c-1.629,0-2.955-1.312-2.955-2.956 c0-1.62,1.32-2.932,2.955-2.932C6.494,37.67,7.809,38.981,7.809,40.602z M2.365,40.613c0,1.396,1.119,2.512,2.51,2.512 c1.387,0,2.488-1.115,2.488-2.512c0-1.384-1.102-2.504-2.488-2.504C3.479,38.109,2.365,39.229,2.365,40.613z M6.332,42.262H5.844 L4.91,40.745H4.184v1.517H3.766v-3.304h1.453c0.268,0,0.549,0,0.793,0.18c0.238,0.136,0.383,0.436,0.377,0.708 c0,0.647-0.465,0.896-1.041,0.899L6.332,42.262z M4.793,40.426c0.455,0,1.17,0.067,1.17-0.601c0-0.491-0.445-0.556-0.854-0.556 H4.178v1.156H4.793z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCE49",
    points: "18.814,34.198 24.127,43.35 14.754,43.35 7.689,34.19  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE49",
    d: "M3.059,7.068L-4.176-5.383c0,0-1.27-1.646-0.699-2.58c0.512-0.844,2.953-0.418,2.953-0.418l66.725,7.495   l-1.129,3.937c0,0-0.375,1.033,0.188,1.22c0.568,0.188,0.941-0.095,1.408-0.374c0.469-0.282,8.156-6.09,8.156-6.09   s0.748-0.468,0.748-1.032c0-0.47-0.564-1.22-0.564-1.22l-6.088-8.06c0,0-0.844-0.938-1.219-0.657   c-0.27,0.199-0.469,0.657-0.469,1.407c0,0.752-0.191,4.03-0.191,4.03l-91.28-16.963c0,0-4.744-1.496-6.84,2.058   c-2.152,3.656,1.972,7.31,1.972,7.31l17.263,22.376L3.059,7.068z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRestaurant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Restaurant.4622a923.svg";
export { ForwardRef as ReactComponent };